<template>
  <div class="modal_box flex-col">
    <div class="select_wrap flex-row align-center">
      <zSelect v-model="queryParams.date" :options="selectList1" class="mr-10" @change="getList" />
      <zSelect v-model="queryParams.platform" :options="selectList2" class="mr-10" @change="getList" />
    </div>

    <div class="list">
      <template v-if="data.length">
        <div v-for="item in data" :key="item.game_id" class="item">
          <div class="mb-5 flex-row align-center justify-between">
            <div class="flex-row align-center">
              <div class="real_money">
                {{ item.game_name }}
              </div>
            </div>
            <div>{{ item.date }}</div>
          </div>
          <div class="mb-5 flex-row align-center justify-between">
            <div>{{ $t("投注") }} &nbsp;<span class="f-w-b color5">{{ item.total_bet }}</span></div>
            <div>{{ $t("总计") }} V/D&nbsp;<span :class="[item.price2 >= 0 ? 'red' : 'green']">{{ item.total_transfer
            }}</span>
            </div>
          </div>
          <div class="flex-row align-center justify-between">
            <div class="flex-row align-center">
              {{ $t("有效投注") }}&nbsp;
              <span class="color5">{{ item.valid_bet }}</span>
            </div>
            <div>
              {{ $t("投注次数") }}&nbsp; {{ item.play_count }}
            </div>
          </div>
        </div>
      </template>
      <zEmpty v-else />
    </div>
    <!-- <div class="bottom_content flex-row flex-wrap align-center">
      <div class="bottom_item flex-row">
        <span class="text">Número acumulado de apostas</span>
        <span class="price">R${{ data.total_recharge || '0.00' }}</span>
      </div>
      <div class="bottom_item flex-row">
        <span class="text">Total de Apostas Válidas</span>
        <span class="price">R${{ data.total_withdraw || '0.00' }}</span>
      </div>
      <div class="bottom_item flex-row">
        <span class="text">Imposto retido na fonte cumulativo</span>
        <span class="price">R${{ data.bonus || '0.00' }}</span>
      </div>
      <div class="bottom_item flex-row">
        <span class="text">Total de V/D</span>
        <span class="yellow">R${{ data.bonus || '0.00' }}</span>
      </div>
    </div> -->
  </div>
</template>
<script>
import zSelect from '../../../components/zSelect.vue';
import zEmpty from '../../../components/zEmpty.vue';
import Fetch from "../../../utils/fetch";
export default {
  components: {
    zSelect,
    zEmpty
  },
  data() {
    return {
      queryParams: {
        date: 0,
        platform: 'pg',
      },
      selectList1: [
        {
          value: 'Hoje',
          key: 0
        },
        {
          value: 'Ontem',
          key: 1
        },
        {
          value: 'Últimos 7 Dias',
          key: 7
        },
        {
          value: 'Últimos 15 Dias',
          key: 15
        },
        {
          value: 'Últimos 30 Dias',
          key: 30
        },
      ],
      selectList2: [],
      data: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(e) {
      Fetch("/record/gamestats", this.queryParams, { method: 'get' }).then((r) => {
        if (r.data) {
          this.data = r.data.stats
          this.selectList2 = r.data.platform_list.map(item => ({
            value: item,
            key: item
          }))
          if (!e) {
            this.queryParams.platform = this.selectList2[0].key
          }
        }
      });
    },
    jumpDetail(item) {
      this.$router.push({
        path: '/report/detail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/css/variables.less";
@import "./comment.less";

.modal_box {
  height: 100%;
}

.select_wrap {
  padding: 10px;
  // overflow-x: auto;
}

.list {
  flex: 1;
  height: 1%;
  overflow-y: auto;
}

.bottom_content {
  height: 68px;
  box-sizing: border-box;
  font-size: 11px;
  width: 100%;
  background-color: @secondary-color;
  padding: 5px 10px;

  .bottom_item {
    width: 50%;
    color: @textcolor5;
    padding-right: 20px;
    box-sizing: border-box;

    .text {
      width: 100px;
    }

    .price {
      color: @textcolor3;
    }
  }
}

.list {
  padding: 0 10px 20px;

  .item {
    padding: 10px;
    border-radius: 5px;
    color: @textcolor5;
    font-size: 10px;

    &:nth-child(odd) {
      background-color: @secondary-color;
    }

    .go_icon {
      font-size: 15px;
      color: @anttextcolor;
    }

    .id {
      width: 50px;
      display: inline-block;
      direction: rtl;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 0 4px;
    }
  }

  .item_info {
    width: 100%;
    padding-right: 10px;
    box-sizing: border-box;

    &:first-child {
      margin-bottom: 5px;
    }

    &.bottom {
      color: @textcolor5;
    }
  }
}

.color5 {
  color: @textcolor3;
}
</style>